import { VIVO_SKIN as o } from "./constants.js";
import { applyAlpha as r } from "../utils/color.js";
const e = {
    vivoPurple: "#660099",
    vivoPurpleDark: "#461E5F",
    vivoPurpleLight10: "#EFE5F4",
    vivoPurpleLight20: "#E0CCEB",
    vivoPurpleLight50: "#B280CC",
    vivoPurpleLight80: "#8433AD",
    vivoPurpleLight90: "#751AA3",
    vivoGreen: "#99CC33",
    vivoGreenDark: "#225C3D",
    vivoGreenLight10: "#EDF8E8",
    vivoGreen25: "#D6EBAD",
    vivoGreenLight30: "#91AE9E",
    vivoBlue: "#00ABDB",
    orange: "#FF9900",
    orange25: "#FFD699",
    orangeDark: "#972A1D",
    orangeLight10: "#FFEFE1",
    orangeLight40: "#FFB84C",
    pink: "#EB3D7D",
    pepper: "#CC1F59",
    pepperDark: "#B71D63",
    pepperDark80: "#8F2052",
    pepperLight10: "#FCE4EF",
    pepperLight30: "#F7B1CB",
    pepperLight40: "#DB628B",
    grey1: "#F6F6F6",
    grey2: "#EEEEEE",
    grey3: "#DDDDDD",
    grey4: "#999999",
    grey5: "#666666",
    grey6: "#000000",
    white: "#FFFFFF",
    darkModeBlack: "#191919",
    darkModeGrey: "#242424",
    darkModeGrey6: "#313235"
}, i = ()=>({
        name: o,
        colors: {
            background: e.white,
            backgroundAlternative: e.grey1,
            backgroundBrand: e.vivoPurple,
            backgroundBrandSecondary: e.vivoPurple,
            backgroundContainer: e.white,
            backgroundContainerHover: r(e.darkModeBlack, 0.03),
            backgroundContainerPressed: r(e.darkModeBlack, 0.05),
            backgroundContainerBrand: e.vivoPurple,
            backgroundContainerBrandHover: r(e.darkModeBlack, 0.2),
            backgroundContainerBrandPressed: r(e.darkModeBlack, 0.4),
            backgroundContainerBrandOverInverse: e.vivoPurpleDark,
            backgroundContainerAlternative: e.grey1,
            backgroundOverlay: r(e.grey6, 0.6),
            backgroundSkeleton: e.grey2,
            backgroundSkeletonInverse: e.vivoPurpleDark,
            backgroundFeedbackBottom: e.vivoPurple,
            appBarBackground: e.white,
            navigationBarBackground: e.vivoPurple,
            skeletonWave: e.grey2,
            borderLow: e.grey1,
            border: e.grey3,
            borderHigh: e.grey5,
            borderSelected: e.vivoPurple,
            coverBackgroundHover: r(e.darkModeBlack, 0.25),
            coverBackgroundPressed: r(e.darkModeBlack, 0.35),
            buttonDangerBackground: e.pepper,
            buttonDangerBackgroundSelected: e.pepperDark,
            buttonDangerBackgroundHover: e.pepperDark,
            buttonLinkBackgroundSelected: e.vivoPurpleLight10,
            buttonLinkBackgroundInverseSelected: r(e.white, 0.1),
            buttonPrimaryBackground: e.vivoPurple,
            buttonPrimaryBackgroundInverse: e.white,
            buttonPrimaryBackgroundSelected: e.vivoPurpleDark,
            buttonPrimaryBackgroundHover: e.vivoPurpleDark,
            buttonPrimaryBackgroundInverseSelected: e.vivoPurpleLight50,
            buttonSecondaryBorder: e.vivoPurple,
            buttonSecondaryBorderSelected: e.vivoPurpleDark,
            buttonSecondaryBackgroundHover: e.vivoPurpleLight10,
            buttonSecondaryBackgroundSelected: e.vivoPurpleLight10,
            buttonSecondaryBorderInverse: e.white,
            buttonSecondaryBorderInverseSelected: e.white,
            buttonSecondaryBackgroundInverseHover: r(e.white, 0.15),
            buttonSecondaryBackgroundInverseSelected: r(e.white, 0.15),
            textButtonPrimary: e.white,
            textButtonPrimaryInverse: e.vivoPurple,
            textButtonPrimaryInverseSelected: e.vivoPurple,
            textButtonSecondary: e.vivoPurple,
            textButtonSecondarySelected: e.vivoPurpleDark,
            textButtonSecondaryInverse: e.white,
            textButtonSecondaryInverseSelected: e.white,
            textLink: e.vivoPurple,
            textLinkInverse: e.white,
            textLinkDanger: e.pepper,
            textLinkSnackbar: e.vivoPurpleLight50,
            control: e.grey3,
            controlActivated: e.vivoPurple,
            controlError: e.pepper,
            loadingBar: e.pink,
            loadingBarBackground: e.pepperLight30,
            toggleAndroidInactive: e.grey2,
            toggleAndroidBackgroundActive: e.vivoPurpleLight20,
            iosControlKnob: e.white,
            divider: e.grey2,
            dividerInverse: r(e.white, 0.2),
            navigationBarDivider: e.vivoPurple,
            badge: e.pepperDark,
            feedbackErrorBackground: e.pepper,
            feedbackInfoBackground: e.grey6,
            brand: e.vivoPurple,
            brandHigh: e.vivoPurpleDark,
            inverse: e.white,
            neutralHigh: e.grey6,
            neutralMedium: e.grey5,
            neutralMediumInverse: e.grey5,
            neutralLow: e.grey1,
            neutralLowAlternative: e.grey2,
            textPrimary: e.grey6,
            textPrimaryInverse: e.white,
            textSecondary: e.grey5,
            textSecondaryInverse: e.vivoPurpleLight20,
            success: e.vivoGreen,
            warning: e.orange,
            error: e.pepper,
            promo: e.vivoPurple,
            highlight: e.pink,
            successLow: e.vivoGreenLight10,
            warningLow: e.orangeLight10,
            errorLow: e.pepperLight10,
            promoLow: e.vivoPurpleLight10,
            brandLow: e.vivoPurpleLight10,
            successHigh: e.vivoGreenDark,
            warningHigh: e.orangeDark,
            errorHigh: e.pepperDark80,
            promoHigh: e.vivoPurple,
            successHighInverse: e.vivoGreenDark,
            warningHighInverse: e.orangeDark,
            errorHighInverse: e.pepperDark80,
            promoHighInverse: e.vivoPurple,
            textNavigationBarPrimary: e.white,
            textNavigationBarSecondary: e.vivoPurpleLight50,
            textNavigationSearchBarHint: e.vivoPurpleLight50,
            textNavigationSearchBarText: e.white,
            textAppBar: e.grey4,
            textAppBarSelected: e.vivoPurple,
            customTabsBackground: e.vivoPurple
        },
        darkModeColors: {
            background: e.darkModeBlack,
            backgroundAlternative: e.darkModeBlack,
            backgroundBrand: e.darkModeBlack,
            backgroundBrandSecondary: e.darkModeBlack,
            backgroundContainer: e.darkModeGrey,
            backgroundContainerHover: r(e.white, 0.03),
            backgroundContainerPressed: r(e.white, 0.05),
            backgroundContainerBrand: e.darkModeGrey,
            backgroundContainerBrandHover: r(e.white, 0.03),
            backgroundContainerBrandPressed: r(e.white, 0.05),
            backgroundContainerBrandOverInverse: e.darkModeGrey,
            backgroundContainerAlternative: e.darkModeGrey,
            backgroundOverlay: r(e.darkModeGrey, 0.8),
            backgroundSkeleton: e.darkModeGrey6,
            backgroundSkeletonInverse: e.darkModeGrey6,
            backgroundFeedbackBottom: e.darkModeBlack,
            appBarBackground: e.darkModeGrey,
            navigationBarBackground: e.darkModeBlack,
            skeletonWave: e.grey5,
            borderLow: e.darkModeBlack,
            border: e.darkModeGrey,
            borderHigh: e.grey5,
            borderSelected: e.vivoPurple,
            coverBackgroundHover: r(e.darkModeBlack, 0.25),
            coverBackgroundPressed: r(e.darkModeBlack, 0.35),
            buttonDangerBackground: e.pepper,
            buttonDangerBackgroundSelected: e.pepperDark,
            buttonDangerBackgroundHover: e.pepperDark,
            buttonLinkBackgroundSelected: r(e.white, 0.08),
            buttonLinkBackgroundInverseSelected: r(e.white, 0.08),
            buttonPrimaryBackground: e.vivoPurpleLight80,
            buttonPrimaryBackgroundInverse: e.vivoPurpleLight80,
            buttonPrimaryBackgroundSelected: e.vivoPurpleDark,
            buttonPrimaryBackgroundHover: e.vivoPurpleDark,
            buttonPrimaryBackgroundInverseSelected: e.vivoPurpleDark,
            buttonSecondaryBackgroundHover: r(e.white, 0.15),
            buttonSecondaryBackgroundSelected: r(e.white, 0.15),
            buttonSecondaryBorder: e.white,
            buttonSecondaryBorderSelected: e.white,
            buttonSecondaryBorderInverse: e.white,
            buttonSecondaryBorderInverseSelected: e.white,
            buttonSecondaryBackgroundInverseHover: r(e.white, 0.15),
            buttonSecondaryBackgroundInverseSelected: r(e.white, 0.15),
            textButtonPrimary: e.grey2,
            textButtonPrimaryInverse: e.grey2,
            textButtonPrimaryInverseSelected: e.grey2,
            textButtonSecondary: e.grey2,
            textButtonSecondarySelected: e.grey2,
            textButtonSecondaryInverse: e.grey2,
            textButtonSecondaryInverseSelected: e.grey2,
            textLink: e.vivoPurpleLight50,
            textLinkInverse: e.vivoPurpleLight50,
            textLinkDanger: e.pepper,
            textLinkSnackbar: e.vivoPurpleLight50,
            control: e.darkModeGrey6,
            controlActivated: e.vivoPurpleLight80,
            controlError: e.pepper,
            loadingBar: e.vivoPurpleLight80,
            loadingBarBackground: e.darkModeGrey6,
            toggleAndroidInactive: e.grey4,
            toggleAndroidBackgroundActive: e.vivoPurpleLight50,
            iosControlKnob: e.grey2,
            divider: r(e.white, 0.05),
            dividerInverse: r(e.white, 0.05),
            navigationBarDivider: e.darkModeBlack,
            badge: e.pepperDark,
            feedbackErrorBackground: e.pepper,
            feedbackInfoBackground: e.grey6,
            brand: e.vivoPurpleLight80,
            brandHigh: r(e.white, 0.05),
            inverse: e.grey2,
            neutralHigh: e.grey2,
            neutralMedium: e.grey5,
            neutralMediumInverse: e.grey5,
            neutralLow: e.darkModeGrey6,
            neutralLowAlternative: e.darkModeGrey6,
            textPrimary: e.grey2,
            textPrimaryInverse: e.grey2,
            textSecondary: e.grey4,
            textSecondaryInverse: e.grey4,
            success: e.vivoGreen,
            warning: e.orange,
            error: e.pepper,
            promo: e.vivoPurpleLight80,
            highlight: e.pink,
            successLow: e.darkModeGrey6,
            warningLow: e.darkModeGrey6,
            errorLow: e.darkModeGrey6,
            promoLow: e.darkModeGrey6,
            brandLow: e.darkModeGrey6,
            successHigh: e.vivoGreenLight30,
            warningHigh: e.orangeLight40,
            errorHigh: e.pepperLight40,
            promoHigh: e.vivoPurpleLight50,
            successHighInverse: e.vivoGreenDark,
            warningHighInverse: e.orangeDark,
            errorHighInverse: e.pepperDark80,
            promoHighInverse: e.vivoPurple,
            textNavigationBarPrimary: e.grey2,
            textNavigationBarSecondary: e.grey4,
            textNavigationSearchBarHint: e.grey4,
            textNavigationSearchBarText: e.grey2,
            textAppBar: e.grey5,
            textAppBarSelected: e.grey2,
            customTabsBackground: e.darkModeBlack
        },
        borderRadii: {
            avatar: "50%",
            bar: "999px",
            button: "4px",
            checkbox: "2px",
            container: "8px",
            indicator: "999px",
            input: "8px",
            legacyDisplay: "16px",
            popup: "8px",
            sheet: "8px"
        },
        textPresets: {
            cardTitle: {
                weight: "regular"
            },
            button: {
                weight: "medium"
            },
            tabsLabel: {
                weight: "medium",
                size: {
                    mobile: 16,
                    desktop: 18
                },
                lineHeight: {
                    mobile: 24,
                    desktop: 24
                }
            },
            link: {
                weight: "medium"
            },
            title1: {
                weight: "medium"
            },
            title2: {
                weight: "light",
                size: {
                    mobile: 20,
                    desktop: 28
                },
                lineHeight: {
                    mobile: 24,
                    desktop: 32
                }
            },
            indicator: {
                weight: "medium"
            },
            navigationBar: {
                weight: "medium"
            },
            text5: {
                weight: "light"
            },
            text6: {
                weight: "light"
            },
            text7: {
                weight: "light"
            },
            text8: {
                weight: "light"
            },
            text9: {
                weight: "light"
            },
            text10: {
                weight: "light"
            }
        }
    });
export { i as getVivoSkin, e as palette };
